export enum RouteName {
    Root = "index",
    Test = "test",
    Home = "home",
    Sign = "sign",
    Auth = "auth",
    Policy = "policy",
    Profile = "profile",
    HomeBlog = "home-blog",
    HomeBlogDetail = "home-blog-blogId",
    HomeEvents = "home-events",
    HomeEventsDetail = "home-events-eventId",
    HomeContact = "home-contact",
    HomeSkillCertify = "home-skillCertify",
    SelectCountry = "select-country",
    AuthUserPasswordChange = "auth-user-passwordChange",
    AuthUserEmail = "auth-user-email",
    AuthUserSocial = "auth-user-social",
    HomeOurTeam = "home-ourteam",
    Dashboard = "dashboard",
    DashboardProfileShare = "dashboard-profile-share",
    DashboardAssessmentSettings = "dashboard-proSkillAssure",
    DashboardAssessmentSettingsManage = "dashboard-proSkillAssure-manage",
    DashboardAssessmentSettingsId = "dashboard-proSkillAssure-manage-assessmentId",
    DashboardAssessmentSettingsCreate = "dashboard-proSkillAssure-create",
    DashboardSkillAdvanceLearnLearnId = "dashboard-skillAdvance-learn-learnId",
    DashboardSkillAdvancePractice = "dashboard-skillAdvance-practice",
    DashboardSkillAdvancePracticeMy = "dashboard-skillAdvance-practice-my",
    DashboardContest = "dashboard-contest",
    DashboardContestDetail = "dashboard-contest-contestId",
    ContestContestIdTaskId = "contest-contestId-taskId",
    LearningCourseIdTaskId = "learning-courseId-taskId",
    LearningAssessmentTrackId = "learning-assessment-trackId",
    LearningAssessmentTrackIdTaskId = "learning-assessment-trackId-taskId",
    LearningLevelAssessmentTrackIdLevelIdTaskTemplateId = "learning-levelAssessment-trackId-levelId-taskTemplateId",
    LearningLevelAssessmentTrackIdLevelId = "learning-levelAssessment-trackId-levelId",
    LearningProSkillAssureAssessmentId = "learning-proSkillAssure-assessmentId",
    LearningProSkillAssureAssessmentIdTaskId = "learning-proSkillAssure-assessmentId-taskId",
    LearningProSkillAssureAssessmentIdCompleted = "learning-proSkillAssure-assessmentId-completed",
    HomePricingCheckout = "home-pricing-checkout",
    ErrorCode = "errorCode",
    Catchall = "catchall"
}

